import {remCalc} from '../_utils'

const borders = {
    null: 0,
    small: `${remCalc(1)} solid`,
    large: `${remCalc(2)} solid`,
}

export default borders
